import { defineMessages } from '@/i18n';

export const listingDetailsMessages = defineMessages({
  detailsBtnLabel: 'platform.app.activations.listings.details.listingsDetailBtn',
  qrCodeButtonLabel: 'platform.app.activations.listings.details.listingsQrBtn',
  priceVisibilityTitle: 'platform.app.activations.listings.details.title',
  priceVisibilityDescription: 'platform.app.activations.listings.details.description',
  priceOptionVisibleLabel: 'platform.app.activations.listings.details.priceOptions.visible',
  priceOptionVisibleDescription: 'platform.app.activations.listings.details.priceOptions.visible.description',
  priceInputLabel: 'platform.app.activations.listings.details.priceInputLabel',
  listedLabel: 'platform.app.activations.listings.details.listedLabel',
  unlistedLabel: 'platform.app.activations.listings.details.unlistedLabel',
  fromPriceInputLabel: 'platform.app.activations.listings.details.fromPriceInputLabel',
  toPriceInputLabel: 'platform.app.activations.listings.details.toPriceInputLabel',
  priceOptionOnRequestLabel: 'platform.app.activations.listings.details.priceOptions.on_request',
  priceOptionOnRequestDescription: 'platform.app.activations.listings.details.priceOptions.on_request.description',
  priceOptionRangeLabel: 'platform.app.activations.listings.details.priceOptions.range',
  priceOptionRangeDescription: 'platform.app.activations.listings.details.priceOptions.range.description',
  listingUpdated: 'platform.app.activations.listings.details.updatedNotificationTitle',
  errorCurrencyRequired: 'platform.app.activations.listings.details.errorCurrencyRequired',
});
